import createStore from "astrid-helpers/src/createStore";
export const [getProofed, setProofed, useProofed] = createStore(0);
//# sourceMappingURL=proofed.js.map